import PropTypes from 'prop-types';

import CharacterCounter from 'apps/interactions/components/character-counter';
import { useInteractionFormContext } from 'apps/interactions/form/context/interaction-form-context';
import { INTERACTION_CHARACTER_LIMIT } from 'apps/proposals/utils';
import { DynamicSearchAndSelect } from '@evertrue/sdk';
import useInteractionPurposesSearch from 'hooks/use-interaction-purposes-search';

const PurposeField = ({
  id,
  onChange,
  onBlur,
  name,
  value,
  required = false,
  field,
  meta,
  helpers,
  interactionStandardFieldsConfig: propConfig,
}) => {
  // Try to get config from context, fallback to props (for legacy form compatibility)
  let contextConfig;
  try {
    const context = useInteractionFormContext();
    contextConfig = context?.interactionStandardFieldsConfig;
  } catch (e) {
    // Context not available, will use props
    contextConfig = null;
  }

  const interactionStandardFieldsConfig = contextConfig || propConfig;
  const isRequired = interactionStandardFieldsConfig?.purpose?.required || required;
  const defaultMaxLength = INTERACTION_CHARACTER_LIMIT?.PURPOSE;
  const maxLength = interactionStandardFieldsConfig?.purpose?.max_length
    ? interactionStandardFieldsConfig.purpose.max_length
    : defaultMaxLength;
  const { purposes, loading, query, handleSearch, clearSearch } = useInteractionPurposesSearch();

  const handleSelect = (selectedValue) => {
    // Handle the selection from DynamicSearchAndSelect
    if (onChange) {
      // Extract the actual value from the selectedValue object
      const actualValue = selectedValue?.value || selectedValue;
      const syntheticEvent = {
        target: { name, value: actualValue },
        currentTarget: { name, value: actualValue },
      };
      onChange(syntheticEvent);
    }
  };

  return (
    <div>
      <DynamicSearchAndSelect
        value={value}
        onSelect={handleSelect}
        placeholder={`Add a purpose${!isRequired ? ' (optional)...' : ''}`}
        searchResults={purposes}
        isSearching={loading}
        query={query}
        handleSearch={handleSearch}
        clearSearch={clearSearch}
        freeSolo={true}
        autoSaveOnBlur={true}
      />

      <CharacterCounter count={value?.length || 0} limit={maxLength} />
    </div>
  );
};

PurposeField.propTypes = {
  id: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  interactionStandardFieldsConfig: PropTypes.object,
  field: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.any,
    checked: PropTypes.bool,
    multiple: PropTypes.bool,
  }),
  meta: PropTypes.shape({
    error: PropTypes.string,
    initialError: PropTypes.string,
    initialTouched: PropTypes.bool,
    initialValue: PropTypes.any,
    touched: PropTypes.bool,
    value: PropTypes.any,
  }),
  helpers: PropTypes.shape({
    setValue: PropTypes.func,
    setTouched: PropTypes.func,
    setError: PropTypes.func,
  }),
};
export default PurposeField;
